import React from 'react';
import PropTypes from 'prop-types';
import './DocumentLink.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faFilePdf from '@fortawesome/fontawesome-free-regular/faFilePdf';
import faFileWord from '@fortawesome/fontawesome-free-regular/faFileWord';
import faFileExcel from '@fortawesome/fontawesome-free-regular/faFileExcel';
import faFileImage from '@fortawesome/fontawesome-free-regular/faFileImage';
import { getLastTokenFromUrl } from 'services/utils/text-util';

export default function DocumentLink(props) {
  const getName = (props) => {
    let result = 'Unknown';
    if (props.url !== null) {
      const name = getLastTokenFromUrl(props.url);
      if (name !== null) {
        result = name;
      }
    } else if (props.file !== null) {
      result = props.file.name;
    }
    return result;
  };

  const getIcon = (props) => {
    let icon;
    let fileName = '';

    if (props.url !== null) {
      const tokens = props.url.split('/');
      if (tokens.length > 0) {
        fileName = tokens[tokens.length - 1];
      }
    } else if (props.file !== null) {
      fileName = props.file.name;
    }

    const fileNameTokes = fileName.split('.');
    let extension = null;
    if (fileNameTokes.length > 0) {
      extension = fileNameTokes[fileNameTokes.length - 1].toLowerCase();
    }
    switch (extension) {
      case 'pdf':
        icon = (
          <FontAwesomeIcon icon={faFilePdf} style={{ color: '#ff0000' }} />
        );
        break;

      case 'doc':
      case 'docx':
        icon = (
          <FontAwesomeIcon icon={faFileWord} style={{ color: '#0051ff' }} />
        );
        break;

      case 'xls':
      case 'xlsx':
        icon = (
          <FontAwesomeIcon icon={faFileExcel} style={{ color: '#00bd09' }} />
        );
        break;

      case 'jpeg':
      case 'jpg':
      case 'png':
      case 'dwg':
        icon = (
          <FontAwesomeIcon icon={faFileImage} style={{ color: '#eb7d34' }} />
        );
        break;

      default:
        icon = null;
        break;
    }

    return icon;
  };

  const getUrl = (props) => {
    if (props.url !== null) {
      return props.url;
    } else if (props.file !== null && props.file.hasOwnProperty('preview')) {
      return props.file.preview;
    } else {
      return null;
    }
  };

  const handleClick = (props, event) => {
    event.stopPropagation(); // to use inside SimpleTable (which prevents defaults on tr clicks)
    props.onClick && props.onClick(event);
  };

  return (
    <div className="document-link">
      <div>
        <a
          className={!props.showLink ? 'not-active' : null}
          href={getUrl(props)}
          target="_blank"
          onClick={(event) => handleClick(props, event)}
        >
          <div>{getName(props)}</div>
        </a>
      </div>
      {props.showIcon && <div>{getIcon(props)}</div>}
    </div>
  );
}

DocumentLink.propTypes = {
  file: PropTypes.any,
  showIcon: PropTypes.bool,
  showLink: PropTypes.bool,
  url: PropTypes.string,
  onClick: PropTypes.func,
};

DocumentLink.defaultProps = {
  file: null,
  showIcon: true,
  showLink: true,
  url: null,
  onClick: null,
};



// WEBPACK FOOTER //
// ./src/components/shared/document/DocumentLink.js